import {
    HELPER_API_BASE_URL,
    // OAUTH_LOGIN_API_BASE_URL,
    bearerAuthHeader,
    // oauthAuthHeader,
    getSavedState,
} from "../utils";

export const userService = {
    validateUserSession,
    fetchUserDetail,
};

async function validateUserSession() {
    try {
        await fetchUserDetailByHelperAPI();
        // await fetchUserDetailByNodeAPI();
        return true;
    } catch (e) {
        throw false;
    }
}

async function fetchUserDetailByHelperAPI() {
    const requestOptions = {
        method: "POST",
        headers: bearerAuthHeader(),
        body: JSON.stringify({ token: getSavedState("token") }),
    };
    const response = await fetch(`${HELPER_API_BASE_URL}/userDetails`, requestOptions);
    return responseHandler(response);
}

// async function fetchUserDetailByNodeAPI() {
//   const requestOptions = {
//     method: "GET",
//     headers: oauthAuthHeader(),
//   };
//   console.log("userservices fetch burada")
//   const response = await fetch(
//     `${OAUTH_LOGIN_API_BASE_URL}/userDetay`,
//     requestOptions,
//     console.log("userfetch=>", response)
//   );
//   return responseHandler(response);
// }

async function fetchUserDetail() {
    const requestOptions = {
        method: "POST",
        headers: bearerAuthHeader(),
        body: JSON.stringify({ token: getSavedState("token") }),
    };
    const response = await fetch(`${HELPER_API_BASE_URL}/userDetails`, requestOptions);
    console.log(response);
    return responseHandler(response);
}

export const responseHandler = (response) => {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return Promise.reject({
                status: response.status,
                statusText: response.statusText,
                message: data.message ? data.message : "Undefined Error",
            });
        }
        localStorage.setItem("image", data.imageFolder)
        return data;
    });
};